import { ComponentType } from 'react'

import { AdminSettingsPage } from 'components/pages/AdminSettingsPage'
import { ComparisonBulkPage } from 'components/pages/ComparisonBulkPage'
import { ComparisonPage } from 'components/pages/ComparisonPage'
import { LandingPage } from 'components/pages/LandingPage'
import { MyVideosPage } from 'components/pages/MyVideosPage'
import { NotFoundPage } from 'components/pages/NotFoundPage'
import { VideoAgentPage } from 'components/pages/VideoAgentPage'

/**
 * Route Configuration
 *
 * All routes defined here automatically get AppLayout applied.
 * This makes it impossible to create a page without the app header.
 *
 * NOTE: Routes must be added here - direct Route JSX in App.tsx
 * should not be used. This ensures the layout is always applied.
 *
 * To add a new page:
 * 1. Create the page component in src/components/pages/
 * 2. Import it at the top of this file
 * 3. Add a new entry to APP_ROUTES below
 *
 * The AppLayout (header + breadcrumbs) will be automatically applied.
 */

export interface AppRoute {
  path: string
  component: ComponentType
  authGuard?: 'required' | 'admin'
}

export const APP_ROUTES: AppRoute[] = [
  {
    path: '/comparison-bulk',
    component: ComparisonBulkPage,
  },
  {
    path: '/comparison',
    component: ComparisonPage,
  },
  {
    path: '/new',
    component: LandingPage,
  },
  {
    path: '/admin/settings',
    component: AdminSettingsPage,
    authGuard: 'required',
  },
  {
    path: '/videos',
    component: MyVideosPage,
    authGuard: 'required',
  },
  {
    path: '/c/:conversationId',
    component: VideoAgentPage,
  },
  {
    path: '/admin',
    component: AdminSettingsPage,
    authGuard: 'admin',
  },
  {
    path: '*',
    component: NotFoundPage,
  },
]
